import { createIconComponent } from './helpers';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons'

export const DownArrow = createIconComponent(faAngleDown);
